/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable max-statements */
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import { useMutation, useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { stateNotificationsEnum } from '../../Utils/notification';
import {
	setSelectedSection,
	setTab
} from '../../../redux/actions/sideBarAction';
import { useDispatch } from 'react-redux';
import { useTypedSelector } from '../../../hooks/useTypeSelector';
import { SetNotificationAction } from '../../../redux/actions/notificationAction';
import { globalEnv } from '../../../config/baseConfig';
import { DataNotFoundAnimation } from '../../Utils/ErrorAnimations/dataNotFoundAnim';
import LoadingAnimComponent from '../../Utils/LoadingAnimations/loadingAnimation';
import { hideSearchbarAction } from '../../../redux/actions/searchBarAction';
import validator from 'validator';
import ParentModal from '../../Utils/Components/parentModal';
import StyleModalContent from '../../SubSections/Topic/TopicStyling/styleModal';
import {
	TopicStyles,
	BasicTopicStyle
} from '../../SubSections/Topic/TopicStyling/StyleComponents/mixins/mixins';
import { ClockTypes } from '../../SubSections/Topic/TopicStyling/StyleComponents/mixins/optionsValues';
import { EmailTag } from '../Outreach/CampaignSection/components/emailTag';
import { EmailsSenderselect } from './emailSenderSelect';

export default function SettingsScreen() {
	const [isChanged, setIsChanged] = useState(false);

	const [defaultTopicCode, setDefaultTopicCode] = useState<string>();
	const [userMaxConnectedDevices, setUserMaxConnectedDevices] = useState(0);
	const [loginAttemptsToBlock, setLoginAttemptsToBlock] = useState(0);
	const [emailmaxBatchSize, setEmailmaxBatchSize] = useState(0);
	const [daysToDeleteUser, setDaysToDeleteUser] = useState(30);
	const [jwtExpiration, setJwtExpiration] = useState('24h');
	const [refreshTokenValidityDays, setRefreshTokenValidityDays] = useState(30);

	const [style, setStyle] = useState<TopicStyles>(BasicTopicStyle);
	const [isStyleModalOpen, setIsStyleModalOpen] = useState(false);
	const [isWarnModalOpen, setIsWarnModalOpen] = useState(false);

	const [selectedDefaultEmailSender, setSelectedDefaultEmailSender] =
		useState<string>('');

	const [isSaving, setIsSaving] = useState(false);

	const [emailErrorMsg, setemailErrorMsg] = useState({
		message: '',
		error: false
	});

	const [emailAdrText, setEmailAdrText] = useState('');
	const [replyToAdrs, setReplyToAdrs] = useState<string[]>([]);

	const verifEmailFormat = (email = '') => {
		if (validator.isEmpty(email, { ignore_whitespace: true })) {
			setemailErrorMsg({
				error: true,
				message: 'Please enter your email address'
			});
			return true;
		} else {
			if (!validator.isEmail(email)) {
				setemailErrorMsg({
					error: true,
					message: 'Email must be a valid format'
				});
				return true;
			} else if (email.indexOf(' ') >= 0) {
				setemailErrorMsg({
					error: true,
					message: 'Email must not contain white spaces'
				});
				return true;
			} else {
				setemailErrorMsg({ error: false, message: '' });
				return false;
			}
		}
	};

	const dispatch = useDispatch();
	dispatch(setSelectedSection('Settings'));
	dispatch(setTab('settings'));
	dispatch(hideSearchbarAction());

	// handleResize() & dimensions are added to update the dashboard card text size when resizing the window
	const [dimensions, setDimensions] = useState({
		width: window.innerWidth,
		height: window.innerHeight
	});
	useEffect(() => {
		function handleResize() {
			setDimensions({
				width: window.innerWidth,
				height: window.innerHeight
			});
		}
		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	async function fetchSettingsData() {
		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};
		const { data } = await axios.get(`${globalEnv.BASE_URL}/settings`, config);
		return data;
	}

	const { ACCESS_TOKEN } = useTypedSelector((state) => state.auth);

	const { data, isLoading, isError } = useQuery([], () => fetchSettingsData(), {
		keepPreviousData: true,
		refetchOnWindowFocus: false,
		staleTime: 5000
	});

	const navigate = useNavigate();

	useEffect(() => {
		if (data != null) {
			setDefaultTopicCode(data.defaultTopicCode);
			setUserMaxConnectedDevices(data.userMaxConnectedDevices);
			setDaysToDeleteUser(data.daysToDeleteUser);
			setLoginAttemptsToBlock(data.loginAttemptsToBlock);
			setRefreshTokenValidityDays(data.refreshTokenValidityDays);
			setJwtExpiration(data.jwtExpiration);
			setEmailmaxBatchSize(data.outreachBatchSize);
			setReplyToAdrs(data.outreachDefaultReplyToAdrs);
			setSelectedDefaultEmailSender(data.outreachDefaultSenderAdr);

			if (data.newStyle != null) {
				let clock;
				try {
					if (data.newStyle.clock.kind === ClockTypes.Analog)
						clock = {
							kind: data.newStyle.clock.kind,
							showSeconds: data.newStyle.clock.showSeconds,
							size: data.newStyle.clock.size,
							isDark: data.newStyle.clock.isDark,
							isNumbered: data.newStyle.clock.isNumbered
						};
					else if (data.newStyle.clock.kind === ClockTypes.Digital)
						clock = {
							kind: data.newStyle.clock.kind,
							showSeconds: data.newStyle.clock.showSeconds,
							size: data.newStyle.clock.size,
							boldness: data.newStyle.clock.boldness,
							showAmPm: data.newStyle.clock.showAmPm,
							showTwentyFour: data.newStyle.clock.showTwentyFour
						};
					else
						clock = {
							kind: data.newStyle.clock.kind,
							size: data.newStyle.clock.size,
							boldness: data.newStyle.clock.boldness
						};
				} catch (e) {
					clock = BasicTopicStyle.clock;
				}

				try {
					let defaultBookmarkList;
					if (data.defaultBookmarkList != null)
						defaultBookmarkList = data.defaultBookmarkList;
					else defaultBookmarkList = BasicTopicStyle.defaultBookmarkList;

					setStyle({
						appearanceStyle: {
							font: data.newStyle.appearanceStyle.font,
							mode: data.newStyle.appearanceStyle.mode,
							opacity: data.newStyle.appearanceStyle.opacity,
							view: data.newStyle.appearanceStyle.view
						},
						quoteStyle: {
							size: data.newStyle.quoteStyle.size,
							useCustomQuote: data.newStyle.quoteStyle.useCustomQuote,
							customQuote:
								data.newStyle.quoteStyle.customQuote != null
									? data.newStyle.quoteStyle.customQuote
									: null
						},
						sidebarStyle: {
							contentWidth: data.newStyle.sidebarStyle.contentWidth,
							width: data.newStyle.sidebarStyle.width,
							view: data.newStyle.sidebarStyle.view
						},
						wallpaperStyle: {
							background: data.newStyle.wallpaperStyle.background,
							blur: data.newStyle.wallpaperStyle.blur,
							brightness: data.newStyle.wallpaperStyle.brightness
						},
						searchbarOptions: data.newStyle.searchbarOptions,
						searchEngines: data.newStyle.searchEngines,
						focusStyle:
							data.newStyle.focusStyle != null
								? {
										myFocus: data.newStyle.focusStyle.myFocus,
										size: data.newStyle.focusStyle.size
								  }
								: BasicTopicStyle.focusStyle,
						greetingStyle:
							data.newStyle.greetingStyle != null
								? { size: data.newStyle.greetingStyle.size }
								: BasicTopicStyle.greetingStyle,
						clock: clock,
						featuresStyle: {
							time: data.newStyle.featuresStyle.time,
							date: data.newStyle.featuresStyle.date,
							weather: data.newStyle.featuresStyle.weather,
							bookmarks: data.newStyle.featuresStyle.bookmarks,
							notes: data.newStyle.featuresStyle.notes,
							quote: data.newStyle.featuresStyle.quote,
							integrations: data.newStyle.featuresStyle.integrations,
							searchBar: data.newStyle.featuresStyle.searchBar
						},
						integrationsStyle: data.newStyle.integrationsStyle,
						bookmarkStyle: {
							selectedBookmarks: data.newStyle.bookmarkStyle.selectedBookmarks,
							blackAndWhite: data.newStyle.bookmarkStyle.blackAndWhite,
							openNewTab: data.newStyle.bookmarkStyle.openNewTab,
							square: data.newStyle.bookmarkStyle.square,
							gap: data.newStyle.bookmarkStyle.gap,
							size: data.newStyle.bookmarkStyle.size
						},
						defaultBookmarkList: defaultBookmarkList
					});
				} catch (e) {
					console.log(e);
				}
			}
		}
	}, [data]);

	async function getEmailingListReq() {
		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};
		const { data } = await axios.get(
			`${globalEnv.BASE_URL}/admin/user/get-email-subscribed-users`,
			config
		);

		let obj = '';
		data.forEach((item: any) => {
			obj = obj + item.email + ';';
		});

		exportUserInfo(obj);
	}

	function exportUserInfo(data: any) {
		const fileData = data;
		const blob = new Blob([fileData], { type: 'text/plain' });
		const url = URL.createObjectURL(blob);
		const link = document.createElement('a');
		link.download = 'user-info.txt';
		link.href = url;
		link.click();
	}

	const emailingList = useQuery([], () => getEmailingListReq(), {
		keepPreviousData: true,
		refetchOnWindowFocus: false,
		staleTime: 5000
	});

	const saveSettingsReq = async () => {
		const dto = {
			defaultTopicCode: defaultTopicCode,
			jwtExpiration: jwtExpiration,
			userMaxConnectedDevices: userMaxConnectedDevices,
			daysToDeleteUser: daysToDeleteUser,
			refreshTokenValidityDays: refreshTokenValidityDays,
			loginAttemptsToBlock: loginAttemptsToBlock,
			outreachDefaultSenderAdr: selectedDefaultEmailSender,
			outreachBatchSize: emailmaxBatchSize,
			outreachDefaultReplyToAdrs: replyToAdrs,
			newStyle: style
		};

		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};
		const { data: response } = await axios.post(
			globalEnv.BASE_URL + '/settings',
			dto,
			config
		);
		return response;
	};

	const saveUser = useMutation(saveSettingsReq, {
		onMutate: () => setIsSaving(true),
		onSuccess: () => {
			setIsSaving(false);
			setIsChanged(false);
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.SUCCESS,
					message: 'Successfully updated settings.'
				})
			);
		},
		onError: () => {
			setIsSaving(false);
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.ERROR,
					message: "Couldn't update settings."
				})
			);
		}
	});

	return (
		<div className="content-container">
			<Scrollbars autoHide>
				{isLoading ? (
					<LoadingAnimComponent />
				) : isError ? (
					<div className="h-full w-full">
						<div className=" flex flex-col mx-auto my-auto text-center align-middle overflow-clip h-full ">
							<div className="mx-auto my-auto self-center">
								<div className="min-h-16">
									<DataNotFoundAnimation height={dimensions.height / 1.5} />
								</div>
								<h3 className="lg:text-2xl text-xl font-bold dark:text-gray-200 text-gray-700 -mt-8">
									{"Couldn't find the data you're looking for!"}
								</h3>
							</div>
						</div>
					</div>
				) : (
					<main className="h-full w-full">
						<section className="relative py-16 transition-all duration-500 bg-gray-300 dark:bg-gray-900">
							<div
								className="relative w-11/12 flex flex-col min-w-0 break-words bg-white dark:bg-gray-800
							transition-all duration-500 mb-6 shadow-xl rounded-lg container mx-auto px-4"
							>
								<div>
									<ParentModal
										visible={isStyleModalOpen}
										setModalOpen={setIsStyleModalOpen}
										isChanged={isChanged}
										setIsChanged={setIsChanged}
										isWarnModalOpen={isWarnModalOpen}
										setIsWarnModalOpen={setIsWarnModalOpen}
									>
										<StyleModalContent
											style={style}
											setStyle={setStyle}
											setModalOpen={setIsStyleModalOpen}
											setIsChanged={setIsChanged}
											isChanged={isChanged}
											isWarnModalOpen={isWarnModalOpen}
											setIsWarnModalOpen={setIsWarnModalOpen}
										/>
									</ParentModal>
								</div>
								<div className="flex w-full justify-end mt-3">
									<button
										className="btn btn-outline btn-sm mt-2 ml-auto"
										type="button"
										style={{ transition: 'all .15s ease' }}
										onClick={() => emailingList.refetch()}
									>
										export emailing list
									</button>

									<button
										type="button"
										className="btn btn-outline btn-sm btn-primary mt-2 ml-3 mr-auto"
										onClick={() => setIsStyleModalOpen(true)}
									>
										Update Style
									</button>
								</div>
								<div className="text-center mt-10">
									<div className="w-full px-3 text-left">
										<label
											className="block uppercase tracking-wide text-gray-700
														dark:text-gray-300 text-xs font-bold mb-2"
										>
											Default topic code
										</label>
										<input
											className="inputStyle"
											id="grid-title"
											placeholder="TopicCode1234"
											value={defaultTopicCode}
											onChange={(e) => {
												setIsChanged(true);
												setDefaultTopicCode(e.target.value);
											}}
										/>
									</div>

									<div className="w-full px-3 mt-4 text-left">
										<label
											className="block uppercase tracking-wide text-gray-700
														dark:text-gray-300 text-xs font-bold mb-2"
										>
											jWT validity
										</label>
										<input
											className="inputStyle"
											id="grid-title"
											placeholder="24h"
											value={jwtExpiration}
											onChange={(e) => {
												setIsChanged(true);
												setJwtExpiration(e.target.value);
											}}
										/>
									</div>

									<div className="w-full px-3 mt-4 text-left">
										<label
											className="block uppercase tracking-wide text-gray-700
														dark:text-gray-300 text-xs font-bold mb-2"
										>
											Refresh token validity (days)
										</label>
										<input
											className="inputStyle"
											id="grid-title"
											placeholder="30"
											value={refreshTokenValidityDays}
											onChange={(e) => {
												setIsChanged(true);
												setRefreshTokenValidityDays(Number(e.target.value));
											}}
										/>
									</div>

									<div className="w-full px-3 mt-4 text-left">
										<label
											className="block uppercase tracking-wide text-gray-700
														dark:text-gray-300 text-xs font-bold mb-2"
										>
											Max Connected devices per user
										</label>
										<input
											className="inputStyle"
											id="grid-title"
											placeholder="Write something about yourself"
											value={userMaxConnectedDevices}
											onChange={(e) => {
												setIsChanged(true);
												setUserMaxConnectedDevices(Number(e.target.value));
											}}
										/>
									</div>

									<div className="w-full px-3 mt-4 text-left">
										<label
											className="block uppercase tracking-wide text-gray-700
														dark:text-gray-300 text-xs font-bold mb-2"
										>
											Days to delete user
										</label>
										<input
											className="inputStyle"
											id="grid-title"
											placeholder="Write something about yourself"
											value={daysToDeleteUser}
											onChange={(e) => {
												setIsChanged(true);
												setDaysToDeleteUser(Number(e.target.value));
											}}
										/>
									</div>

									<div className="w-full px-3 mt-4 text-left">
										<label className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-xs font-bold mb-2">
											Login Attempts To Block
										</label>
										<input
											className="inputStyle"
											id="grid-title"
											placeholder="Write something about yourself"
											value={loginAttemptsToBlock}
											onChange={(e) => {
												setIsChanged(true);
												setLoginAttemptsToBlock(Number(e.target.value));
											}}
										/>
									</div>

									<div className="w-full px-3 mt-4 text-left">
										<label className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-xs font-bold mb-2">
											Outreach email max batch size
										</label>
										<input
											className="inputStyle"
											id="grid-title"
											placeholder="Write something about yourself"
											value={emailmaxBatchSize}
											onChange={(e) => {
												setIsChanged(true);
												setEmailmaxBatchSize(Number(e.target.value));
											}}
										/>
									</div>

									<div className="w-full px-3 mt-4 text-left">
										<div className="w-full h-auto">
											<label className="block uppercase tracking-wide text-gray-700  dark:text-gray-300 text-xs font-bold">
												Email sender address
											</label>
											<div className="">
												<EmailsSenderselect
													selectedEmailAdrs={selectedDefaultEmailSender}
													setSelectedEmailAdrs={setSelectedDefaultEmailSender}
													setIsChanged={setIsChanged}
												/>
											</div>
										</div>
									</div>

									<div className="w-full px-3 mt-4 text-left">
										<div className="w-full h-auto">
											<label className="block uppercase tracking-wide text-gray-700  dark:text-gray-300 text-xs font-bold mb-2">
												Reply to addresses
											</label>
											<div className="flex flex-row">
												<input
													className="inputStyle py-2"
													id="grid-last-name"
													type="text"
													placeholder="address@email.com"
													onChange={(e) => {
														if (!emailErrorMsg.error)
															setEmailAdrText(e.target.value);
													}}
													onBlur={(e) => {
														verifEmailFormat(e.target.value);
													}}
													onFocus={() => {
														setemailErrorMsg({ error: false, message: '' });
													}}
													value={emailAdrText}
												/>
												{emailErrorMsg.error ? (
													<p className="text-red-500 text-xs italic text-right ml-auto h-4">
														{emailErrorMsg.message}
													</p>
												) : (
													<div className="mb-4" />
												)}
												<button
													type="button"
													className="btn btn-outline btn-sm btn-primary mr-2 ml-3 mt-1 "
													onClick={() => {
														if (!verifEmailFormat(emailAdrText)) {
															const updatedEmailAdrs: string[] =
																replyToAdrs != null
																	? replyToAdrs.concat(emailAdrText)
																	: [emailAdrText];
															setReplyToAdrs(updatedEmailAdrs);
															setEmailAdrText('');
														}
													}}
												>
													Add Email address
												</button>
											</div>
											<div className="flex flex-wrap space-x-2 mt-3">
												{replyToAdrs != null &&
													replyToAdrs.map((adr, index) => (
														<div className="mb-2">
															<EmailTag
																key={adr}
																adr={adr}
																index={index}
																setEmailAdrs={setReplyToAdrs}
																allAdrs={replyToAdrs}
															/>
														</div>
													))}
											</div>
										</div>
									</div>
								</div>

								<div className="w-full px-4">
									<div className="py-6 px-3 flex flex-row">
										<div className="justify-end">
											<button
												className="btn btn-outline btn-sm mt-2 mr-1 "
												type="button"
												style={{ transition: 'all .15s ease' }}
												onClick={() => navigate('../documents')}
											>
												Cancel
											</button>
											{isChanged && (
												<button
													disabled={isLoading ? true : false}
													type="button"
													className="btn btn-outline btn-sm btn-primary mt-2 ml-1"
													onClick={() => saveUser.mutate()}
												>
													save
													{isSaving ? (
														<div className="pl-2">
															<svg
																role="status"
																className="w-5 h-5 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
																viewBox="0 0 100 101"
																fill="none"
																xmlns="http://www.w3.org/2000/svg"
															>
																<path
																	d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
																	fill="currentColor"
																></path>
																<path
																	d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
																	fill="currentFill"
																></path>
															</svg>
														</div>
													) : (
														<h5 className="text-xs ml-2">💾</h5>
													)}
												</button>
											)}
										</div>
									</div>
								</div>
							</div>
						</section>
					</main>
				)}
			</Scrollbars>
		</div>
	);
}
